// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header.header-page-event-date .logo-container .back-container.hidden {
  display: block;
}

.page-event-date .page-title {
  padding: 0 50px;
}

.page-event-date .page-description {
  padding: 0 10px;
}

.page-event-date .input-container {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.page-event-date .input-container input {
  cursor: pointer;
  height: 60px;
  width: 100%;
  min-width: 328px;
  background: none;
  outline: none;
  border: 1px solid var(--input-border-color);
  padding: 16px;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  letter-spacing: -0.024em;
}

.page-event-date .calendar-icon-container {
  display: inline-block;
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -13.5px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: -0.024em;
}

.page-event-date .text-with-icon-wrapper {
  padding: 12px;
  border-radius: 12px;
  background-color: white;
}

.page-event-date .text-with-icon-wrapper .text {
  margin-left: 12px;
  color: var(--dark-gray);
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
}

.page-event-date .button-container {
  display: flex;
  flex-direction: column-reverse;
  text-align: center;
}

.page-event-date .skip-button {
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: var(--dark-gray);
  display: block;
  margin: 0 auto;
  background-color: transparent;
}

.page-event-date .next-button {
  height: auto;
  max-height: 70px;
  margin-bottom: 20px;

  font-weight: 700;
  line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/event-date.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;;EAEnB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["#header.header-page-event-date .logo-container .back-container.hidden {\n  display: block;\n}\n\n.page-event-date .page-title {\n  padding: 0 50px;\n}\n\n.page-event-date .page-description {\n  padding: 0 10px;\n}\n\n.page-event-date .input-container {\n  position: relative;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.page-event-date .input-container input {\n  cursor: pointer;\n  height: 60px;\n  width: 100%;\n  min-width: 328px;\n  background: none;\n  outline: none;\n  border: 1px solid var(--input-border-color);\n  padding: 16px;\n  border-radius: 10px;\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 22px;\n  text-align: left;\n  letter-spacing: -0.024em;\n}\n\n.page-event-date .calendar-icon-container {\n  display: inline-block;\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  margin-top: -13.5px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 25px;\n  letter-spacing: -0.024em;\n}\n\n.page-event-date .text-with-icon-wrapper {\n  padding: 12px;\n  border-radius: 12px;\n  background-color: white;\n}\n\n.page-event-date .text-with-icon-wrapper .text {\n  margin-left: 12px;\n  color: var(--dark-gray);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.page-event-date .button-container {\n  display: flex;\n  flex-direction: column-reverse;\n  text-align: center;\n}\n\n.page-event-date .skip-button {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  color: var(--dark-gray);\n  display: block;\n  margin: 0 auto;\n  background-color: transparent;\n}\n\n.page-event-date .next-button {\n  height: auto;\n  max-height: 70px;\n  margin-bottom: 20px;\n\n  font-weight: 700;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
